import en from './strings.en';

const ru = {
    search: 'Найти перевозчиков',
    accessToEndOfDay: 'Поиск по направлениям внутри РФ до конца дня',
    accessTo: 'Доступ открыт до',
    currency: 'рублей.',
    remaining: 'Будет действовать до 23:59 (ещё {{hours}} ч {{minutes}} мин)',
    free: 'Бесплатно',
    outsideRussia: 'вне РФ',
};

export default { ru, en: { ...ru, ...en} };
